import Vue from "vue";
import VueI18n from "vue-i18n";
import elementLocale from "element-ui/lib/locale";
import elementZh from "element-ui/lib/locale/lang/zh-CN";
import elementFr from "element-ui/lib/locale/lang/fr";
import zhCN from "./locales/zh-CN";
import frFR from "./locales/fr-FR";

Vue.use(VueI18n);

export const LANG_ZH = "zh-CN";
export const LANG_FR = "fr-FR";
export const STORAGE_KEY = "rider-web-lang";

export function getStoredLocale() {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === LANG_ZH || saved === LANG_FR) {
    return saved;
  }
  return LANG_FR;
}

function applyElementLocale(lang) {
  elementLocale.use(lang === LANG_FR ? elementFr : elementZh);
}

const i18n = new VueI18n({
  locale: getStoredLocale(),
  fallbackLocale: LANG_ZH,
  messages: {
    [LANG_ZH]: zhCN,
    [LANG_FR]: frFR,
  },
  silentTranslationWarn: true,
});

applyElementLocale(i18n.locale);
document.documentElement.lang = i18n.locale;
document.title = i18n.t("app.title");

export function setAppLocale(lang) {
  const next = lang === LANG_FR ? LANG_FR : LANG_ZH;
  i18n.locale = next;
  localStorage.setItem(STORAGE_KEY, next);
  applyElementLocale(next);
  document.documentElement.lang = next;
  return next;
}

export function getApiLanguageHeader() {
  return i18n.locale;
}

export default i18n;
